import { utilSlice } from '@store';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Popup } from '../Popup';

const ToastPopup = () => {
  const dispatch = useDispatch();

  const { disappearTimeoutInSeconds, isShown, text, variant } = useSelector(
    (state) => state.utilSlice.toast
  );

  useEffect(() => {
    if (disappearTimeoutInSeconds) {
      dispatch(utilSlice.actions.setToastIsShown(true));

      setTimeout(() => {
        dispatch(utilSlice.actions.setToastIsShown(false));
        dispatch(utilSlice.actions.setToastDisappearTimeoutInSeconds(0));
      }, disappearTimeoutInSeconds * 1000);
    }
  }, [disappearTimeoutInSeconds]);

  return <Popup isPopupVisible={isShown} text={text} variant={variant} />;
};

ToastPopup.propTypes = {};

ToastPopup.defaultProps = {};

export default ToastPopup;
